import { useState } from 'react';
import { Button } from '@/components/ui/button';

interface StoryAdProps {
  onAction?: () => void;
}

export default function StoryAd({ onAction }: StoryAdProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative w-full h-full flex items-center justify-center bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 overflow-hidden"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Close button removed as requested */}

      {/* Ad content */}
      <div className="relative z-10 max-w-md text-center px-6">
        <h2 className="text-white text-3xl font-bold mb-4">Discover More on MoZo</h2>
        <p className="text-white text-lg mb-6">
          Share your moments with friends and connect with creators worldwide.
        </p>
        <Button
          onClick={onAction}
          className="bg-white text-purple-600 hover:bg-gray-100 font-semibold px-8 py-2 rounded-full transform transition-transform duration-300"
          style={{
            transform: isHovered ? 'scale(1.05)' : 'scale(1)'
          }}
        >
          Explore Now
        </Button>
      </div>

      {/* Visual elements */}
      <div className="absolute inset-0 z-0">
        {/* Animated circles */}
        <div className="absolute top-1/4 left-1/4 w-32 h-32 rounded-full bg-white opacity-10 animate-pulse"></div>
        <div className="absolute bottom-1/3 right-1/3 w-24 h-24 rounded-full bg-white opacity-10 animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 right-1/4 w-16 h-16 rounded-full bg-white opacity-10 animate-pulse" style={{ animationDelay: '0.5s' }}></div>

        {/* Sponsored tag */}
        <div className="absolute bottom-4 left-4 bg-black bg-opacity-30 px-3 py-1 rounded-full">
          <span className="text-white text-xs font-medium">Sponsored</span>
        </div>
      </div>
    </div>
  );
}
